import { HttpParams, HttpHeaders } from '@angular/common/http';

export class BaseRequestOptionsArgs {
  headers?: HttpHeaders | {
    [header: string]: string | string[];
  };
  // observe?: 'body';
  params?: HttpParams | {
    [param: string]: string | string[];
  };
  reportProgress?: boolean;
  // responseType?: 'json';
  withCredentials?: boolean;
}

export class ClientRequestOptionsArgs extends BaseRequestOptionsArgs {
  responseType?: 'json';
  observe?: 'body';
}


export class ArrayBufferRequestOptionsArgs extends BaseRequestOptionsArgs {
  responseType: 'arraybuffer';
  observe?: 'body';
}
